module.exports = "/_next/static/images/business-world-fd545ca853ddeb278a70a2013c748940.svg";